var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5023 13.3334C9.96147 13.3334 12.8356 10.4593 12.8356 7.00009C12.8356 3.54092 9.96148 0.666748 6.48959 0.666748C3.03042 0.666748 0.15625 3.54092 0.15625 7.00009C0.168968 10.4593 3.04313 13.3334 6.5023 13.3334ZM6.5023 12.2779C3.57727 12.2779 1.22453 9.92512 1.22453 7.00009C1.22453 4.07505 3.56456 1.72231 6.48959 1.72231C9.41462 1.72231 11.7674 4.07505 11.7801 7.00009C11.7928 9.93784 9.44005 12.2779 6.5023 12.2779ZM6.37513 8.28456C6.68035 8.28456 6.88383 8.09379 6.88383 7.83944V7.76314C6.88383 7.41977 7.08731 7.20356 7.51971 6.91106C8.11743 6.51681 8.54982 6.14801 8.54982 5.4104C8.54982 4.36756 7.63416 3.8207 6.57861 3.8207C5.51033 3.8207 4.81087 4.32939 4.64555 4.88896C4.62011 4.9907 4.59467 5.09245 4.59467 5.19419C4.59467 5.46126 4.82359 5.62659 5.02707 5.62659C5.38316 5.62659 5.43402 5.43582 5.63751 5.2069C5.84099 4.86353 6.14622 4.66006 6.55318 4.66006C7.11275 4.66006 7.48155 4.97799 7.48155 5.44854C7.48155 5.86822 7.21449 6.0717 6.68035 6.45323C6.23524 6.75845 5.89186 7.08911 5.89186 7.69955V7.77585C5.87914 8.11923 6.05719 8.28456 6.37513 8.28456ZM6.36241 10.1413C6.7185 10.1413 7.03643 9.86153 7.03643 9.49272C7.03643 9.12391 6.73122 8.84413 6.36241 8.84413C5.99361 8.84413 5.68838 9.12391 5.68838 9.49272C5.68838 9.84881 5.99361 10.1413 6.36241 10.1413Z",
    fill: "#ffffff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6521a668b17bea430ee4aed2323b845c.svg";
export { ForwardRef as ReactComponent };